import { LoadingIcon } from "melco-ui";
// import { useTranslation } from "react-i18next";
import { useAddSupplier } from "../../hooks/suppliers/useAddSupplier";
import { THREADS } from "../../helper/suppliers";



type AddThreadsSupplierProps = {

  setIsAddThreadsSupplierDrawerOpenAction: (v: boolean, id: string) => void
};

export const AddThreadsSupplier: React.FC<
  AddThreadsSupplierProps
> = ({ setIsAddThreadsSupplierDrawerOpenAction }) => {
  const [addSupplier, isLoading] = useAddSupplier(THREADS);

  //  const { t } = useTranslation();
  return (
    <>
      {
        <div
          key="add-threads-suppliers"

          onClick={async () => {
            const supplier = await addSupplier();
            if (supplier) {
              console.log(supplier)
              setIsAddThreadsSupplierDrawerOpenAction(true, supplier.id);
            }
          }}

        >
          {isLoading && <LoadingIcon />} Thread
        </div>
      }
    </>


  );
};
